module.exports = __webpack_public_path__ + "static/media/drive.e55a6a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/drive.png
// module id = 967
// module chunks = 0